import React from "react";

const FourNotFour = () => {
  return <div>404 Page Not Found</div>;
};

export default FourNotFour;
